import React from 'react'
import { Json } from './json';
import './json.css';

interface Props {
    value    : object;
    expandTo : number;
}

export class JsonPrittyPrint extends React.Component<Props> 
{
    render()
    {
        return (
            <pre className="json">
              <code>
                <Json value= { this.props.value } expandTo={ this.props.expandTo } />
              </code>
            </pre>);
    }
}

